import {
  Thought,
  ThoughtType,
  ToolResultComponent,
  AgentUpdateComponent,
  ToolCallComponent
} from './types';

// Registry por tipo de thought
type ComponentRegistry = {
  agent_update: Map<string, AgentUpdateComponent>;
  tool_result: Map<string, ToolResultComponent>;
  tool_call: Map<string, ToolCallComponent>;
};

const registry: ComponentRegistry = {
  agent_update: new Map(),
  tool_result: new Map(),
  tool_call: new Map()
};

// Función genérica de registro
export const registerComponent = <T extends ThoughtType>(
  thoughtType: T,
  identifier: string,
  component: T extends 'agent_update'
    ? AgentUpdateComponent
    : T extends 'tool_result'
    ? ToolResultComponent
    : ToolCallComponent
) => {
  // Normalizar el identificador antes de guardarlo para que coincida con la búsqueda
  const normalizedIdentifier = normalizeIdentifier(identifier);
  registry[thoughtType].set(normalizedIdentifier, component as any);
};

// Función genérica de obtención con fallback
export const getComponent = (thought: Thought) => {
  const typeRegistry = registry[thought.type];

  // 1. Intentar match exacto (normalizado)
  const identifier = getIdentifier(thought);

  // 🔍 DEBUG: Log para ver qué tool_name está llegando
  if (thought.type === 'tool_result') {
    const registryKeys = Array.from(typeRegistry.keys());
    console.log('🔍 [Registry] getComponent for tool_result:', {
      originalToolName: thought.tool_name,
      normalizedIdentifier: identifier,
      availableKeys: registryKeys,
      hasMatch: typeRegistry.has(identifier)
    });
  }

  const exactMatch = typeRegistry.get(identifier);
  if (exactMatch) return exactMatch;

  // 2. Fallback a componente por defecto del tipo
  const defaultComponent = typeRegistry.get('*');
  if (defaultComponent) {
    if (thought.type === 'tool_result') {
      console.log('⚠️ [Registry] Default fallback for:', identifier);
    }
    return defaultComponent;
  }

  // 3. Fallback global (se manejará en ThoughtRenderer)
  console.warn('⚠️ [Registry] No se encontró componente para:', {
    type: thought.type,
    identifier,
    availableKeys: Array.from(typeRegistry.keys())
  });
  return null;
};

// Helper para normalizar identificadores (case-insensitive, normalizar guiones)
function normalizeIdentifier(identifier: string): string {
  return identifier
    .toLowerCase()
    .replace(/[-_]/g, '_') // Normalizar guiones y guiones bajos a guiones bajos
    .trim();
}

// Helper para obtener identificador según tipo
function getIdentifier(thought: Thought): string {
  switch (thought.type) {
    case 'agent_update':
      return thought.agent || '*';
    case 'tool_result':
      const toolName = thought.tool_name || '*';
      // Normalizar el tool_name para matching más flexible
      return normalizeIdentifier(toolName);
    case 'tool_call':
      const callToolName = thought.tool_name || '*';
      return normalizeIdentifier(callToolName);
    default:
      return '*';
  }
}

// Exportar registry para extensión
export { registry };






